import type { SxProps, Theme } from "@mui/material/styles";

export const mergeSx = (base: SxProps<Theme>, sx: SxProps<Theme> | undefined): SxProps<Theme> => [
  ...(Array.isArray(base) ? base : [base]),
  ...(Array.isArray(sx) ? sx : [sx]),
];
